import { LitElement, html } from 'lit';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { style } from './iconic-loan-checks.style.js';
import { globalStyle } from '../../../../global-styles.style.js';

class RefiIconicLoanChecks extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiIconicLoanChecks');

    this.isCapOneLoan = null;
  }

  static properties = {
    loanObject: { type: Object },
    isCapOneLoan: { type: Boolean },
    isInvalid: { type: Boolean },
  };

  connectedCallback() {
    super.connectedCallback();
    this.debug.log('loaded with', this.loanObject);
  }

  static styles = [style, globalStyle];

  render() {
    return html`
      <fs-body-text variant="primary" size="medium"
        >Is this car currently financed by Capital One?</fs-body-text
      >
      <div role="radiogroup" aria-labelledby="caponeLoanCheckLabel">
        <div>
          <fs-radio
            id="caponeLoanCheckYes"
            name="caponeLoanCheck"
            value="yes"
            required
            ?checked="${this.isCapOneLoan !== null && this.isCapOneLoan}"
            @change="${this.capOneLoanChange}"
            @blur="${this.capOneLoanChange}"
            data-e2e-ref="caponeLoanCheckYes"
            >Yes
          </fs-radio>
        </div>
        <div>
          <fs-radio
            id="caponeLoanCheckNo"
            name="caponeLoanCheck"
            value="no"
            required
            ?checked="${this.isCapOneLoan !== null && !this.isCapOneLoan}"
            @change="${this.capOneLoanChange}"
            @blur="${this.capOneLoanChange}"
            data-e2e-ref="caponeLoanCheckNo"
            >No
          </fs-radio>
        </div>
        <fs-body-text
          size="small"
          variant="feedback-negative"
          id="capOneLoanCheckInvalid"
          hidden
        >
          Please select if this vehicle is currently financed by Capital One
        </fs-body-text>
      </div>
    `;
  }

  firstUpdated() {
    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name: 'isCapOneLoan',
          isValid: false,
        },
      })
    );
  }

  capOneLoanChange(ev) {
    this.isCapOneLoan = ev.target.value === 'yes';
    this.loanObject.isCapitalOneLoaned = ev.target.value;
    this.shadowRoot.getElementById('capOneLoanCheckInvalid').hidden = true;

    this.dispatchEvent(
      new CustomEvent('validity', {
        detail: {
          name: 'isCapOneLoan',
          isValid: true,
        },
      })
    );
  }

  closeModal() {
    this.shadowRoot.getElementById('payoffAmountModal').closeModalDialog();
  }
}

customElements.define('refi-iconic-loan-checks', RefiIconicLoanChecks);
